import { render, staticRenderFns } from "./AdminCreateCompany.vue?vue&type=template&id=706641a9"
import script from "./AdminCreateCompany.vue?vue&type=script&lang=ts"
export * from "./AdminCreateCompany.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports